import {useMemo} from 'react';
import {useGetUserQuery} from 'modules/user/services';

export const useIsWorker = () => {
    const {data: user} = useGetUserQuery();

    return useMemo<boolean>(() => 'employee' === user?.userGroupName, [user?.userGroupName]);
};
